import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/upload.svg'
import _imports_1 from '@/assets/icon/search.svg'
import _imports_2 from '@/assets/icon/reviewed_icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-f236fc22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component dicom_file_upload" }
const _hoisted_2 = { class: "function-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<svg width=\"23\" height=\"23\" viewBox=\"0 0 23 23\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-f236fc22><g clip-path=\"url(#clip0_1279_12843)\" data-v-f236fc22><path d=\"M18.6875 5.9225L17.0775 4.3125L11.5 9.89L5.9225 4.3125L4.3125 5.9225L9.89 11.5L4.3125 17.0775L5.9225 18.6875L11.5 13.11L17.0775 18.6875L18.6875 17.0775L13.11 11.5L18.6875 5.9225Z\" fill=\"white\" data-v-f236fc22></path></g><defs data-v-f236fc22><clipPath id=\"clip0_1279_12843\" data-v-f236fc22><rect width=\"23\" height=\"23\" fill=\"white\" data-v-f236fc22></rect></clipPath></defs></svg>", 1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<svg width=\"25\" height=\"25\" viewBox=\"0 0 25 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-f236fc22><g clip-path=\"url(#clip0_1069_3899)\" data-v-f236fc22><path d=\"M14.5833 5.72917V4.16667H10.4167V5.72917H5.72917V7.8125H6.25V19.3854C6.25 20.1823 6.94792 20.8333 7.8125 20.8333H17.1875C18.0521 20.8333 18.75 20.1875 18.75 19.3854V7.8125H19.2708V5.72917H14.5833ZM10.9375 18.4219H9.375V10.224H10.9375V18.4219ZM15.625 18.4219H14.0625V10.224H15.625V18.4219Z\" fill=\"white\" data-v-f236fc22></path></g><defs data-v-f236fc22><clipPath id=\"clip0_1069_3899\" data-v-f236fc22><rect width=\"25\" height=\"25\" fill=\"white\" data-v-f236fc22></rect></clipPath></defs></svg>", 1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "search-box" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "loading_box"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-area" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "spinner" })
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "table_header" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<svg class=\"icon\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-f236fc22><mask id=\"mask0_334_286\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"16\" height=\"16\" data-v-f236fc22><rect width=\"16\" height=\"16\" fill=\"#D9D9D9\" data-v-f236fc22></rect></mask><g mask=\"url(#mask0_334_286)\" data-v-f236fc22><path d=\"M6.36686 12L2.56686 8.20001L3.51686 7.25001L6.36686 10.1L12.4835 3.98334L13.4335 4.93334L6.36686 12Z\" data-v-f236fc22></path></g></svg>", 1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_1437_76098)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.99917 8.75L10.0296 5.25H3.96875L6.99917 8.75Z",
    fill: "white"
  })
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_1437_76098" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "14",
      height: "14",
      fill: "white"
    })
  ])
], -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_1437_76098)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.99917 8.75L10.0296 5.25H3.96875L6.99917 8.75Z",
    fill: "white"
  })
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_1437_76098" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "14",
      height: "14",
      fill: "white"
    })
  ])
], -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_1437_76098)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.99917 8.75L10.0296 5.25H3.96875L6.99917 8.75Z",
    fill: "white"
  })
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_1437_76098" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "14",
      height: "14",
      fill: "white"
    })
  ])
], -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_1437_76098)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.99917 8.75L10.0296 5.25H3.96875L6.99917 8.75Z",
    fill: "white"
  })
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_1437_76098" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "14",
      height: "14",
      fill: "white"
    })
  ])
], -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_1437_76098)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.99917 8.75L10.0296 5.25H3.96875L6.99917 8.75Z",
    fill: "white"
  })
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_1437_76098" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "14",
      height: "14",
      fill: "white"
    })
  ])
], -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = {
  key: 1,
  class: "upload_list_box my-scroll"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<svg class=\"icon\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-f236fc22><mask id=\"mask0_334_286\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"16\" height=\"16\" data-v-f236fc22><rect width=\"16\" height=\"16\" fill=\"#D9D9D9\" data-v-f236fc22></rect></mask><g mask=\"url(#mask0_334_286)\" data-v-f236fc22><path d=\"M6.36686 12L2.56686 8.20001L3.51686 7.25001L6.36686 10.1L12.4835 3.98334L13.4335 4.93334L6.36686 12Z\" data-v-f236fc22></path></g></svg>", 1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = ["onMouseenter", "onMouseleave"]
const _hoisted_38 = ["onMouseenter", "onMouseleave"]
const _hoisted_39 = ["onMouseenter", "onMouseleave"]
const _hoisted_40 = {
  key: 0,
  src: _imports_2
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "-", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "-", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "-", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "대기중", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "-", -1))
const _hoisted_46 = [
  _hoisted_41,
  _hoisted_42,
  _hoisted_43,
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "Click the upload button at the top,"),
  /*#__PURE__*/_createElementVNode("h3", null, "or Drag the file to the area.")
], -1))
const _hoisted_48 = [
  _hoisted_47
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.activeDeleteBtn)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "upload-box btn__default gray",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileClick && _ctx.handleFileClick(...args)))
          }, _hoisted_4))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "cancel-box btn__default gray",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleCancelClick && _ctx.handleCancelClick(...args)))
          }, _hoisted_6)),
      _createElementVNode("div", {
        class: _normalizeClass(["delete-box btn__default gray", [{'active': _ctx.selectedCount>0}, {'clickable': _ctx.searchRes.length>0}]]),
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleDeleteClick && _ctx.handleDeleteClick(...args)))
      }, _hoisted_8, 2),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "Search",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchText) = $event)),
          onKeyup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.searchDicomFile && _ctx.searchDicomFile(...args)))
        }, null, 544), [
          [_vModelText, _ctx.searchText]
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["drop_box", { 'drag_over': _ctx.isDragOver }]),
      onDrop: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args))),
      onDragover: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handleDragOver && _ctx.handleDragOver(...args))),
      onDragenter: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.handleDragEnter && _ctx.handleDragEnter(...args))),
      onDragleave: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.handleDragLeave && _ctx.handleDragLeave(...args)))
    }, [
      (_ctx.loading&&_ctx.disableFileSelect)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        type: "file",
        accept: ".dcm",
        ref: "fileInput",
        style: {"display":"none"},
        onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleFileInputChange && _ctx.handleFileInputChange(...args))),
        multiple: ""
      }, null, 544),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", {
          class: _normalizeClass({ 'active': _ctx.checkAll })
        }, [
          (_ctx.activeDeleteBtn)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "checkbox",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleCheckboxAllClick()))
              }, _hoisted_16))
            : _createCommentVNode("", true),
          _createTextVNode(" Patient ID "),
          (_openBlock(), _createElementBlock("svg", {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggleListSort('id'))),
            class: _normalizeClass({asc: _ctx.sortState.order === 'id' && _ctx.sortState.direction === 'asc', desc: _ctx.sortState.order === 'id' && _ctx.sortState.direction === 'desc'}),
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, _hoisted_19, 2))
        ], 2),
        _createElementVNode("div", null, [
          _createTextVNode(" Patient Name "),
          (_openBlock(), _createElementBlock("svg", {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toggleListSort('name'))),
            class: _normalizeClass({asc: _ctx.sortState.order === 'name' && _ctx.sortState.direction === 'asc', desc: _ctx.sortState.order === 'name' && _ctx.sortState.direction === 'desc'}),
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, _hoisted_22, 2))
        ]),
        _createElementVNode("div", null, [
          _createTextVNode(" Study Date "),
          (_openBlock(), _createElementBlock("svg", {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.toggleListSort('date'))),
            class: _normalizeClass({asc: _ctx.sortState.order === 'date' && _ctx.sortState.direction === 'asc', desc: _ctx.sortState.order === 'date' && _ctx.sortState.direction === 'desc'}),
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, _hoisted_25, 2))
        ]),
        _createElementVNode("div", null, [
          _createTextVNode(" Score "),
          (_openBlock(), _createElementBlock("svg", {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.toggleListSort('score'))),
            class: _normalizeClass({asc: _ctx.sortState.order === 'score' && _ctx.sortState.direction === 'asc', desc: _ctx.sortState.order === 'score' && _ctx.sortState.direction === 'desc'}),
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, _hoisted_28, 2))
        ]),
        _createElementVNode("div", null, [
          _createTextVNode(" Confirm "),
          (_openBlock(), _createElementBlock("svg", {
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.toggleListSort('confirm'))),
            class: _normalizeClass({asc: _ctx.sortState.order === 'confirm' && _ctx.sortState.direction === 'asc', desc: _ctx.sortState.order === 'confirm' && _ctx.sortState.direction === 'desc'}),
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, _hoisted_31, 2))
        ])
      ]),
      (_ctx.dicomFilesList.length > 0 || _ctx.pendingListCount > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchRes, (dicom) => {
              return (_openBlock(), _createElementBlock("div", {
                key: dicom.unique_filename,
                class: _normalizeClass(["table_body", [{'clickable': dicom.status=='Completed' || dicom.status=='Shared Existing' || !_ctx.withCAD}, [{'selected': dicom.unique_filename == _ctx.dicomFile.unique_filename}]]]),
                onClick: ($event: any) => (_ctx.selectDicomFile(dicom))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass([{ 'active': dicom.selected }, "patient-id-wrapper"])
                }, [
                  (_ctx.activeDeleteBtn && (dicom.status === 'Completed' || dicom.status === 'Shared Existing' || dicom.status === 'Failed' || !_ctx.withCAD))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "checkbox",
                        onClick: ($event: any) => (_ctx.handleCheckboxClick(dicom, !dicom.selected))
                      }, _hoisted_36, 8, _hoisted_34))
                    : _createCommentVNode("", true),
                  _createElementVNode("h3", {
                    class: "text-ellipsis",
                    onMouseenter: ($event: any) => (_ctx.handleMouseEnterId($event, dicom)),
                    onMouseleave: ($event: any) => (_ctx.handleMouseLeaveId(dicom))
                  }, _toDisplayString(dicom.patient_id), 41, _hoisted_37),
                  _createElementVNode("div", {
                    class: _normalizeClass([{show: dicom.showIdTooltip}, "tooltip"])
                  }, _toDisplayString(dicom.patient_id), 3)
                ], 2),
                _createElementVNode("div", null, [
                  _createElementVNode("h3", {
                    class: "text-ellipsis",
                    onMouseenter: ($event: any) => (_ctx.handleMouseEnterName($event, dicom)),
                    onMouseleave: ($event: any) => (_ctx.handleMouseLeaveName(dicom))
                  }, _toDisplayString(dicom.patient_name), 41, _hoisted_38),
                  _createElementVNode("div", {
                    class: _normalizeClass([{show: dicom.showNameTooltip}, "tooltip"])
                  }, _toDisplayString(dicom.patient_name), 3)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("h3", {
                    class: "text-ellipsis",
                    onMouseenter: ($event: any) => (_ctx.handleMouseEnterDate($event, dicom)),
                    onMouseleave: ($event: any) => (_ctx.handleMouseLeaveDate(dicom))
                  }, _toDisplayString(_ctx.formatStudyDate(dicom.study_date)), 41, _hoisted_39),
                  _createElementVNode("div", {
                    class: _normalizeClass([{show: dicom.showDateTooltip}, "tooltip"])
                  }, _toDisplayString(_ctx.formatStudyDate(dicom.study_date)), 3)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass({reviewed: dicom.is_reviewed})
                }, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.statusText(dicom)), 1)
                ], 2),
                _createElementVNode("div", null, [
                  (dicom.is_reviewed)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_40))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_33))
            }), 128)),
            (_ctx.searchText == '')
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.pendingListCount, (count) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: count,
                    class: "table_body pending"
                  }, _hoisted_46))
                }), 128))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "upload_info",
            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleFileClick && _ctx.handleFileClick(...args)))
          }, _hoisted_48))
    ], 34)
  ]))
}